interface Props {
  searchTags: string[];
}

const DiseaseEncyclopediaSearchTagList = (props: Props) => {
  return (
    <div className='mx-[24px] flex items-start gap-[20px]'>
      <div className='flex flex-wrap gap-[6px]'>
        {props.searchTags.map((tag) => (
          <span
            key={tag}
            className='typography-ui-13m block rounded-[40px] border border-gray-100 border-solid px-[12px] py-[4px] text-gray-600'
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DiseaseEncyclopediaSearchTagList;
